"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react"); // @ts-check
// Note, branching disobeys one of the hook rules because
// it wraps hooks in a condition. For this reason, the branch
// is cached and kept the same regardless of updates.

/**
 * @param {Function} condition
 * @param {Function} left
 * @param {Function} right
 * @returns {Function}
 */


var branch = function branch(condition, left) {
  var right = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (x) {
    return x;
  };
  return function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var conditionResult = (0, _react.useMemo)(function () {
      return condition(props);
    }, []);
    return conditionResult ? left(props) : right(props);
  };
};

var _default = branch;
exports.default = _default;